module.exports = __webpack_public_path__ + "img/last_pic.d00f7eb6.png";